export function validateRequired(validate, e, name = false, value = false) {
  // Is event passed in?
  if (e !== false) {
    name = e.target.name;
    value = e.target.value;
  }
  
  if (value !== '') {
    validate[name] = 'has-success'
  } else {
    validate[name] = 'has-danger'
  }

  return validate
}

export function validateRequiredCheckbox(validate, e, name = false, value = false) {
  // Is event passed in?
  if (e !== false) {
    name = e.target.name;
    value = e.target.value;
  }
  
  if (value !== 'true') {
    validate[name] = 'has-success'
  } else {
    validate[name] = 'has-danger'
  }
  
  return validate
}

export function validateEmail(validate, e) {
  // Must be valid email
  const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(e.target.value)) {
    validate.email = 'has-success'
  } else {
    validate.email = 'has-danger'
  }
  
  return validate
}